import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import NotFound from 'components/NotFound';
import FlightEdit from 'components/FlightEdit';
import PageWithSidebar from 'components/PageWithSidebar';
import FlightSidebar from 'components/FlightSidebar';

import { withData } from 'lib';
import { FlightEditPageQuery } from '__generated__/FlightEditPageQuery.graphql';

const query = graphql`
  query FlightEditPageQuery($id: ID!, $first: Int!, $after: String) {
    flight(id: $id) {
      name

      ...FlightSidebar_flight
      ...FlightEdit_flight
    }
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<FlightEditPageQuery>;
};

type RouteParams = {
  id: string;
};

const breadcrumbs = [{ link: '/flights', name: 'Skrydžiai' }];

const FlightEditPage: FC<Props> = ({ preloadedQuery }) => {
  const { flight } = usePreloadedQuery<FlightEditPageQuery>(
    query,
    preloadedQuery
  );

  if (!flight) {
    return <NotFound />;
  }

  return (
    <PageWithSidebar
      sidebar={<FlightSidebar flight={flight} />}
      breadcrumbs={[...breadcrumbs, { name: flight.name }]}>
      <FlightEdit flight={flight} />
    </PageWithSidebar>
  );
};

export default withData<FlightEditPageQuery, RouteParams>({
  query,
  variables: ({ routeParams, currentUser }) => ({
    id: routeParams.id,
    first: currentUser.itemsPerPage,
  }),
})(FlightEditPage);
